import Masonry from 'masonry-layout';
import config from './config';

const { baseUrl } = config();

const classToggle = () => {
	// this is used in the pricing page to see all the features.
	const formContainer = document.querySelector('#form-container-group');

	if (formContainer) {
		window.addEventListener('click', (event) => {
			if (event.target.matches('#form-toggle a')) {
				formContainer.classList.add('form-displayed');
			}
		});
	}

	const integrationTabPattern = document.querySelectorAll('.pe-integration-page-tab-pattern .wp-block-button');
	window.addEventListener('click', (event) => {
		if (event.target.matches('.pe-integration-page-tab-pattern .wp-block-button__link')) {
			integrationTabPattern.forEach(function (intgTab) {
				intgTab.classList.remove('selected');
			});
			const parentTarget = event.target.parentElement;
			parentTarget.classList.add('selected');
			if (parentTarget.classList.contains('pe-integration-page-browsers-tab-btn')) {
				document.querySelector('.pe-integration-page-tab-pattern-browsers').scrollIntoView();
			} else if (parentTarget.classList.contains('pe-integration-page-platforms-tab-btn')) {
				document.querySelector('.pe-integration-page-tab-pattern-platforms').scrollIntoView();
			} else if (parentTarget.classList.contains('pe-integration-page-tools-tab-btn')) {
				document.querySelector('.pe-integration-page-tab-pattern-tools').scrollIntoView();
			}
		}
	});

	// this is used in the competitor page to see all the features.
	const seeAllFeaturesButton = document.querySelector('.see-all-features-button');
	const peCompetitorPageFeatureListGroup = document.querySelector('.pe-competitor-page-feature-list-group');
	const seeAllFeatures = document.querySelector('.see-all-features');

	if (seeAllFeaturesButton && peCompetitorPageFeatureListGroup && seeAllFeatures) {
		seeAllFeaturesButton.addEventListener('click', () => {
			peCompetitorPageFeatureListGroup.style.height = '100%';
			seeAllFeatures.style.display = 'none';
		});
	}

	const demoHelper = {
		notifications: {
			welcome: {
				title: 'Thank you for joining our list 🙂',
				options: {
					body: 'Latest offers & alerts will be on your way anytime.',
					tag: 'welcome_notification',
					icon: baseUrl + '/wp-content/themes/pushengage-theme/images/push_logo.png',
					data: '/case-studies'
				}
			},
			breakingNews: {
				title: 'ALERT! Worst Hailstorm Predicted',
				options: {
					body: 'We recommend you to stay home & safe.',
					tag: 'welcome_notification',
					icon: baseUrl + '/wp-content/themes/pushengage-theme/images/push_logo.png',
					data: '/features',
					image: baseUrl + '/wp-content/themes/pushengage-theme/images/push_image5.png'
				}
			},
			sale: {
				title: 'FLAT 40% Sale on all products',
				options: {
					body: 'Grab your item before it runs out of stock.',
					tag: 'welcome_notification',
					icon: baseUrl + '/wp-content/themes/pushengage-theme/images/push_logo.png',
					data: '/pricing',
					image: baseUrl + '/wp-content/themes/pushengage-theme/images/push_image2.png'
				}
			},
			abandonedCart: {
				title: 'You forgot Nike running sneakers in cart',
				options: {
					body: 'We have limited offer of 10%',
					tag: 'welcome_notification',
					icon: baseUrl + '/wp-content/themes/pushengage-theme/images/push_logo.png',
					data: '/signup',
					image: baseUrl + '/wp-content/themes/pushengage-theme/images/push_image1.png',
					actions: [{ title: 'GRAB NOW', action: '1' }]
				}
			},
			newBlog: {
				title: 'New Dessert Delicacies ALERT!',
				options: {
					body: '5 easy dessert recipes for Christmas evening.',
					tag: 'welcome_notification',
					icon: baseUrl + '/wp-content/themes/pushengage-theme/images/push_logo.png',
					data: '/blog',
					image: baseUrl + '/wp-content/themes/pushengage-theme/images/push_image4.png',
					actions: [
						{ title: 'Read Now', action: '1' },
						{ title: 'PIN IT', action: '2' }
					]
				}
			},
			reEngagement: {
				title: 'Did you miss out on popular reads this month?',
				options: {
					body: 'Check out our summary post',
					tag: 'welcome_notification',
					icon: baseUrl + '/wp-content/themes/pushengage-theme/images/push_logo.png',
					data: '/contact-us',
					image: baseUrl + '/wp-content/themes/pushengage-theme/images/push_image6.png',
					actions: [{ title: 'Read More', action: '1' }]
				}
			}
		},
		getServiceWorkerFilePath() {
			return '/service-worker.js';
		},
		showAlert(msg) {
			// eslint-disable-next-line no-alert
			alert(msg);
		},
		getRegistration() {
			const self = this;
			return new Promise(function (resolve, reject) {
				navigator.serviceWorker
					.getRegistrations()
					.then(function (registrations) {
						if (registrations && registrations.length) {
							resolve(registrations[0]);
						} else {
							navigator.serviceWorker
								.register(self.getServiceWorkerFilePath())
								.then(function () {
									navigator.serviceWorker.ready.then(resolve).catch(reject);
								})
								.catch(reject);
						}
					})
					.catch(reject);
			});
		},
		requestPermission() {
			return new Promise(function (resolve) {
				if (Notification.permission === 'default') {
					Notification.requestPermission().then(resolve);
				} else {
					resolve(Notification.permission);
				}
			});
		},
		showNotification(notification) {
			const self = this;
			// Check that Notification is supported,
			if (!('Notification' in window)) {
				self.showAlert('This browser does not support notification');
				return;
			}

			// Check that service workers are supported,
			if (!('serviceWorker' in navigator)) {
				self.showAlert(
					"Can't display notification in this browser. Service workers aren't supported probably because of private browsing mode. Please try disabling that feature and try again."
				);
				return;
			}

			// Check the current Notification permission.
			// If its denied, it's a permanent block until the
			// user changes the permission
			if (Notification.permission === 'denied') {
				self.showAlert('Notification permission has been denied. Please enable permission');
				return;
			}

			self.requestPermission().then(function (permission) {
				if (permission !== 'granted') {
					self.showAlert('Please allow notification permission to see demo notification');
					return;
				}

				self.getRegistration()
					.then(function (registration) {
						notification.options.tag = `${notification.options.tag}-${new Date().getTime()}`;
						if (registration.showNotification) {
							registration.showNotification(notification.title, notification.options);
						} else {
							delete notification.options.actions;
							const n = new Notification(notification.title, notification.options);
							n.onclick = function () {
								window.open(notification.options.data);
								this.close();
							};

							n.onclose = function () {
								this.close();
							};
						}
					})
					.catch(function (err) {
						// eslint-disable-next-line no-console
						console.error(err);
						self.showAlert('Failed to display notification. Try again.');
					});
			});
		}
	};

	jQuery(document).ready(function () {
		jQuery(document).on('click', '.wp-block-pushengage-theme-browser-info', function () {
			const $link = jQuery(this).find('.browser-name a');
			if ($link.length > 0) {
				window.location.href = $link.attr('href');
			}
		});

		jQuery(document).on(
			'click',
			'.pe-integration-page-tab-pattern-platforms .wp-block-column, .pe-integration-page-tab-pattern-tools .wp-block-column',
			function () {
				const $link = jQuery(this).find('figcaption a');
				if ($link.length > 0) {
					window.location.href = $link.attr('href');
				}
			}
		);

		// See a Live Push Notification Example handling on home page
		jQuery(document).on('click', '.wp-block-button__link', function () {
			jQuery('.wp-block-pe-ndemo-grid').css('display', 'grid');
		});
		// swap the icon image on hover
		jQuery('.wp-block-pe-ndemo-item').hover(
			function () {
				const $this = jQuery(this);
				const $img = $this.find('img');
				const src = $img.attr('src');
				const hover = $img.data('hover');
				$img.attr('src', hover);
				$img.data('hover', src);
			},
			function () {
				const $this = jQuery(this);
				const $img = $this.find('img');
				const src = $img.attr('src');
				const hover = $img.data('hover');
				$img.attr('src', hover);
				$img.data('hover', src);
			}
		);
		jQuery('.wp-block-pe-ndemo-item').on('click', function () {
			const notifType = jQuery(this).data('notif');
			if (demoHelper.notifications[notifType]) {
				demoHelper.showNotification(demoHelper.notifications[notifType]);
			}
		});

		jQuery('.common-card .text-author__name').on('click', function () {
			window.location.href = '/pricing';
		});

		const $bodyFeatures = jQuery('body.features');
		const $bodySolutions = jQuery('body.solutions');
		const $videoCon = '<div class="embed-container"><iframe src="';
		const $videoConEnd = '?rel=0" frameborder="0" allowfullscreen></iframe></div>';
		let $vidUrl, $vidHref;

		// TODO: scope this into a function.
		if ($bodyFeatures.length > 0) {
			$vidUrl = $bodyFeatures.find('.pe-hero-header-v1 .pe-hero-header-media');
			if ($vidUrl.find('a').length > 0) {
				$vidHref = $videoCon + $vidUrl.find('a').attr('href') + $videoConEnd;
				$vidUrl.html($vidHref);
			}
		}

		if ($bodySolutions.length > 0) {
			$vidUrl = $bodySolutions.find('.pe-hero-header-v3 .pe-hero-header-media');
			if ($vidUrl.find('a').length > 0) {
				$vidHref = $videoCon + $vidUrl.find('a').attr('href') + $videoConEnd;
				$vidUrl.html($vidHref);
			}
		}

		jQuery('.dot').on('click', function () {
			const postId = jQuery(this).data('did');
			jQuery('.list-popular .list-posts').addClass('non');
			jQuery('.list-popular .list-posts.list-' + postId).removeClass('non');
			jQuery('.dot').removeClass('selected');
			jQuery(this).addClass('selected');
		});

		jQuery('.nav-li button.left').on('click', function () {
			let selected = parseInt(jQuery('.dot.selected').data('did'), 10);
			if (selected === 1) {
				selected = jQuery('.dot').length;
			} else {
				selected -= 1;
			}

			jQuery('.list-popular .list-posts').addClass('non');
			jQuery('.list-popular .list-posts.list-' + selected).removeClass('non');
			jQuery('.dot').removeClass('selected');
			jQuery('.dot.d-' + selected).addClass('selected');
		});

		jQuery('.nav-li button.right').on('click', function () {
			let selected = parseInt(jQuery('.dot.selected').data('did'), 10);
			if (selected === jQuery('.dot').length) {
				selected = 1;
			} else {
				selected += 1;
			}

			jQuery('.list-popular .list-posts').addClass('non');
			jQuery('.list-popular .list-posts.list-' + selected).removeClass('non');
			jQuery('.dot').removeClass('selected');
			jQuery('.dot.d-' + selected).addClass('selected');
		});

		// case studies grid
		const grid = document.querySelector('.am-cs-con');
		if (grid !== null) {
			new Masonry(grid, {
				itemSelector: '.wp-block-column',
				gutter: 16
			});
		}

		// TODO: filtering is not working fix it by adding cs data attribute to case studies items
		// by creating a higher order component to add the attribute
		/*
		jQuery('label.holder').on('click', function () {
			const $this = jQuery(this);
			const cs = $this.data('cs');
			const isChecked = $this.find('input').is(':checked');


			if (isChecked) {
				jQuery('.am-cs-con > .wp-block-column').hide();
				const $target = jQuery('.wp-block-pushengage-theme-testimonial.' + cs);
				$target.parent('.wp-block-column').show();
			} else {
				jQuery('.am-cs-con > .wp-block-column').show();
			}

			// show all item if no option is selected
			if (jQuery('.type-selector > label.holder > input:checked').length === 0) {
				jQuery('.am-cs-con > .wp-block-column').show();
			}

			new Masonry(document.querySelector('.am-cs-con'), {
				itemSelector: '.wp-block-column',
				gutter: 16
			});
		});
		*/

		jQuery(
			'.pe-contact-page-technical-basic-questions .wp-block-button__link.has-theme-gray-light-background-color'
		).on('click', function (e) {
			e.preventDefault();
			if (
				jQuery('.pe-contact-page-technical-basic-questions').hasClass('open-form') &&
				jQuery('main.wpf-sub').length > 0
			) {
				// Do nothing. For sake of clarity.
				jQuery('main').removeClass('wpf-sub');
			} else {
				jQuery('.pe-contact-page-technical-basic-questions').toggleClass('open-form');
			}

			jQuery('.pe-contact-page-contact-form-container').show();
			jQuery('.pe-contact-page-contact-form-sidebar').show();
			jQuery('.pe-contact-page-success').hide();
		});

		// show contact form if url has #pe-contact-form
		if (window.location.hash === '#pe-contact-form') {
			if (jQuery('#pe-ticketinvite').length > 0) {
				jQuery('.pe-contact-page-technical-basic-questions').addClass('open-form');
				jQuery('.pe-contact-page-contact-form-container').show();
				jQuery('.pe-contact-page-contact-form-sidebar').show();
				jQuery('.pe-contact-page-success').hide();

				// scroll to the form
				jQuery('html, body').animate(
					{
						scrollTop: jQuery('#pe-ticketinvite').offset().top
					},
					500
				);
			}
		}

		jQuery(
			'#pe-ticketinvite .pe-showcontact-from-block'
		).on('click', function (e) {
			e.preventDefault();
			if (
				jQuery('.pe-contact-page-technical-basic-questions').hasClass('show-section')
			) {
				// Do nothing. For sake of clarity.
				jQuery('main').removeClass('wpf-sub');
			} else {
				jQuery('.pe-contact-page-technical-basic-questions').toggleClass('show-section');
			}
		});

		if (jQuery('main.wpf-sub').length > 0) {
			jQuery('.pe-contact-page-technical-basic-questions').addClass('open-form');
			jQuery('.pe-contact-page-contact-form-container').hide();
			jQuery('.pe-contact-page-contact-form-sidebar').hide();
			jQuery('.pe-contact-page-contact-form')
				.append(
					'<div class="pe-contact-page-success"><p>Thank you for submitting your question. We`ll get back to you as soon as possible.</p></div>'
				)
				.show();
		}

		try {
			if (document.referrer) {
				let utmQuery = decodeURIComponent(window.location.search.substring(1)),
					utmCampaign = '',
					utmMedium = '',
					utmSource = '';
				if (utmQuery) {
					utmQuery = utmQuery.split('&');
					if (utmQuery.length > 0) {
						utmQuery.forEach(function (utmParam) {
							const thisParam = utmParam.split('=');
							if (thisParam.length > 0) {
								if (typeof thisParam[1] !== 'undefined') {
									if ('utm_campaign' === thisParam[0]) {
										utmCampaign = thisParam[1];
									}

									if ('utm_medium' === thisParam[0]) {
										utmMedium = thisParam[1];
									}

									if ('utm_source' === thisParam[0]) {
										utmSource = thisParam[1];
									}
								}
							}
						});
					}
				}

				const referralJson = {
					referral_url: document.referrer,
					utm_campaign: utmCampaign,
					utm_medium: utmMedium,
					utm_source: utmSource
				};
				document.cookie = 'referral=' + JSON.stringify(referralJson);
			}
		} catch (err) {
			// Cookie fail.
		}

		jQuery(document).on('submit', '.pushengage-cta-test-drive-form', function (e) {
			if (!jQuery(this).parent('.wp-block-pushengage-theme-action-call').hasClass('is-style-noinput')) {
				e.preventDefault();
				jQuery(this).find('.pushengage-cta-test-drive-form__button').click();
				return false;
			}
		});
	});
};

export default classToggle;
